import React, {Fragment, useState} from 'react';
import './styles.scss'
import HeaderDropdown from "../pages/reports/components/dropdown";
import HeaderButton from "../pages/reports/components/button";
import AddFileModal from "./addFileModal";
import StatusChangeModal from "./statusChangeModal";
import {apiPost} from "../services/apiClient";
import {multiPrint} from "../services/print";
import {toast} from "react-toastify";
import ConfirmModal from "../components/Modals/ConfirmModal";
import {getRoles} from "../services/userRights";


const LoadBtn = ({ reload }) => {
    const roles = getRoles() || [];
    const isAdmin = roles.includes('Admin');
    const isCoordinator = roles.includes('Coordinator');
    const isFinancial = roles.includes('Financial');

    const [open, setOpen] = useState({});

    const options = [];
    if (isCoordinator) {
        options.push({
            key: '1',
            onClick: () => setOpen({
                type: 1,
                text: 'Загрузка отправленных посылок',
                template: null,
                templateUrl: 'templateSentParcels',
                saveFullUrl: 'parcels/import/excel/uploadSentParcels'
            }),
            text: 'Загрузка отправленных посылок',
        });
    }
    if (isCoordinator || isFinancial) {
        options.push({
            key: '2',
            onClick: () => setOpen({
                type: 2,
                text: 'Загрузка фактических данных',
                template: 'Actual data template.xlsx',
                saveFullUrl: 'parcels/import/excel/actualData'
            }),
            text: 'Загрузка фактических данных',
        });
    }
    if (isAdmin) {
        options.push({
            key: '4',
            onClick: () => setOpen({
                type: 4,
                text: 'Массовый расчет',
                template: 'Calculation template.xlsx',
                saveUrl: 'massCalc'
            }),
            text: 'Массовый расчет',
        });
    }

    if (options.length < 1) {
        return null;
    }

    return <Fragment>
        <HeaderDropdown
            options={options}
            icon='doc'
            label='Загрузка данных'
            value={null}
            onChange={null}
        />
        <AddFileModal
            reload={reload}
            extensions={'XLSX, XLSM, XLS, XLTX и XLTM'}
            params={open}
            open={open.type || false}
            onClose={() => setOpen({})}
        />
    </Fragment>
}

const ParcelsButtons = ({reload, selectedItems, setLoading, loading, history, clearFilters, clearDisabled}) => {
    const [deleteItems, setDelete] = useState(false);
    const loadSelectedParcelWaybills = () => {
        setLoading(true)
        let request = {
            ids: selectedItems
        };
        apiPost('parcels/list/documents/waybills', request)
            .then(data => {
                setLoading(false)
                if (!data.entries || data.entries.length < 1) {
                    toast.error('Не найдено накладных для печати')
                } else {
                    let files = data.entries.map((entry) => {
                        let fileUrl = getApiBaseUrl() + "parcels/documents/file/" + entry.key + "/download";
                        return {
                            url: fileUrl,
                            contentType: entry.contentType
                        };
                    });
                    multiPrint(files);
                }
            })
            .catch(err => {
                setLoading(false)
                toast.error(err.message || 'Произошла ошибка')
            });
    }

    const deleteParcels = () => {
        apiPost('parcels/list/author/delete', {ids: selectedItems}).then(d => {
            d.warnings && toast.error(d.warnings)
            setDelete(false);
            !d.warnings && toast.success('Посылки удалены')
            reload && reload();
        }).catch(e => {
            setDelete(false);
            toast.error('При удалении произошла ошибка')
            console.log(e)
        })
    }

    const authorButtonsView = () => {
        let view = false;
        const roles = getRoles() || [];
        const rolesForView = ['Author', 'Coordinator']
        roles.forEach(r => {
            if (rolesForView.includes(r))
                view = true
        })
        return view;
    }
    return (
        <div className='grid-btns'>
            <LoadBtn reload={reload}/>
            <StatusChangeModal
                reload={reload}
                selectedIds={selectedItems}
                setLoading={setLoading}
                loading={loading}
            >
                <HeaderButton
                    disabled={!selectedItems.length}
                    icon='array'
                    name='Массовые операции'
                />
            </StatusChangeModal>
            <HeaderButton
                disabled={!selectedItems.length}
                icon='print'
                name='Печать накладных'
                onClick={loadSelectedParcelWaybills}
            />
            {authorButtonsView() && <HeaderButton
                disabled={!selectedItems.length}
                icon='copy'
                name='Копировать'
                onClick={() => {
                    selectedItems.length !== 1
                        ? toast.error('В таблице не должно быть отмечено более одной посылки при копировании')
                        : history.push(`/parcels/copy/${selectedItems[0]}`)
                }}
            />}
            {authorButtonsView() && <HeaderButton
                disabled={!selectedItems.length}
                icon='delete'
                name='Удалить'
                onClick={() => setDelete(true)}
            />}
            <HeaderButton
                disabled={clearDisabled}
                icon='close'
                name='Сбросить фильтры'
                onClick={clearFilters}
            />

            <ConfirmModal
                open={deleteItems}
                setOpen={setDelete}
                label='Удаление посылок'
                onConfirm={deleteParcels}
            >
                Вы уверены, что хотите удалить выбранные посылки?
            </ConfirmModal>
        </div>
    );
};

export default ParcelsButtons;


// WEBPACK FOOTER //
// ./App/grids/parcelsButtons.jsx